"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.builder = void 0;
function createWithValueFunction(rule) {
    const withValue = (value) => {
        rule.values.push(value);
        return {
            withValues: createWithValuesFunction(rule),
            withValue: createWithValueFunction(rule),
            build: createBuildFunction(rule),
        };
    };
    return withValue;
}
function createWithValuesFunction(rule) {
    const withValues = (...values) => {
        rule.values = [...rule.values, ...values];
        return {
            withValues: createWithValuesFunction(rule),
            withValue: createWithValueFunction(rule),
            build: createBuildFunction(rule),
        };
    };
    return withValues;
}
function createBuildFunction(rule) {
    const build = (errorMessage) => {
        return {
            type: rule.type,
            values: rule.values.join(),
            errorMessage,
        };
    };
    return build;
}
exports.builder = {
    withValues: (...values) => {
        const rule = {
            type: 'isIn',
            values: values || [],
        };
        return {
            withValues: createWithValuesFunction(rule),
            withValue: createWithValueFunction(rule),
            build: createBuildFunction(rule),
        };
    },
    withValue: (value) => {
        const rule = {
            type: 'isIn',
            values: [value],
        };
        return {
            withValues: createWithValuesFunction(rule),
            withValue: createWithValueFunction(rule),
            build: createBuildFunction(rule),
        };
    },
};
//# sourceMappingURL=IsInBuilder.js.map